import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const list = css`
  list-style-type: none;
  text-align: left;
  margin: 0 0 ${spacing.xxl}px 0;
  padding: 0;
`;

export const item = css`
  margin: ${spacing.sm}px 0;
`;

export const link = css`
  ${theme.responsiveText.BODY.SM}
  color: var(--neutral-black-base);
  text-decoration: none;
  font-weight: normal;
  &:hover {
    color: var(--brand-purple-base);
    text-decoration: underline;
  }
`;
